// removed by extract-text-webpack-plugin
module.exports = {"product-info":"product-info","product-title":"product-title","product-description":"product-description","conpany-wrap":"conpany-wrap","company-image-wrap":"company-image-wrap","company-name":"company-name","view-info":"view-info","view-info-link":"view-info-link","product-price":"product-price","product-phone":"product-phone","product-from":"product-from","product-call":"product-call","price":"price","send-request":"send-request"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/sub-view/product-info/style.scss
// module id = ./components/product-detail/sub-view/product-info/style.scss
// module chunks = 0